// src/screens/sales/order/hooks/useOrder.ts

import { useCallback, useState, useEffect, useMemo } from 'react'
import { OrderInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { useDispatch, useSelector } from 'react-redux'
import { selectOrderList, setOrderList } from '../../../../store/slices/orderListSlice'
import {
  DeliveryType,
  OrderStatus,
  PaymentMethod,
  PaymentStatus,
} from '../../../../common/types/enums'

export const initialData: OrderInterface = {
  status: OrderStatus.NEW as OrderStatus,
  deliveryType: DeliveryType.UNSET as DeliveryType,
  paymentMethod: PaymentMethod.UNSET as PaymentMethod,
  paymentStatus: PaymentStatus.PENDING as PaymentStatus,
  isPaid: false,
  subtotal: 0,
  deliveryFee: 0,
  total: 0,
  items: [] as Array<{
    itemId: number
    name: string
    price: number
    quantity: number
    total: number
    added?: boolean
  }>,
  notes: '',
  description: '',
  orderNumber: '',
  fullAddressId: undefined as number | undefined,
  storeId: undefined as number | undefined,
  clusterId: undefined as number | undefined,
  userId: undefined as number | undefined,
  phone_number: '',
  baseAddress: {
    city: { latitude: '', longitude: '', value: '' },
    address: { latitude: '', longitude: '', value: '' },
  },
}

export const useOrder = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [data, setData] = useState<OrderInterface>()
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [current, setCurrent] = useState<OrderInterface>()
  const list = useSelector(selectOrderList)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getOrderList({ sort: 'id', order: 'DESC' })
      setLoading(false)
      if (result) dispatch(setOrderList(result))
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi, dispatch])

  const startEdit = (el: OrderInterface) => {
    if (detailsModalActive) setDetailsModalActive(false)
    setCurrent({ ...el })
    setEdit(true)
    setModalActive(true)
  }

  const startCreate = () => {
    setCurrent(undefined)
    setModalActive(true)
  }

  const showDetails = useCallback((el: OrderInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

  const uuidMap = useMemo(() => new Map(list.map((item) => [item.uuid, item])), [list])

  const onReadQr = (value: string) => {
    const current = uuidMap.get(value)
    if (current) showDetails(current)
  }

  useEffect(() => {
    getList()
  }, [getList])

  useEffect(() => {
    if (!modalActive) setData(undefined)
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    onReadQr,
    initialData,
    startCreate,
    loading,
  }
}
